import * as d3 from "d3";

export const hoursScopeChoices = [
    { value: 24, label: "1 Day" },
    { value: 24 * 7, label: "1 Week" },
    { value: 24 * 30, label: "1 Month" },
    { value: 24 * 90, label: "3 Months" },
  ];

  export const categoryChoices = [
    { value: 5, label: "5 Cats." },
    { value: 10, label: "10 Cats." },
    { value: 15, label: "15 Cats." },
    { value: 20, label: "20 Cats." },
    { value: 30, label: "30 Cats." },
  ];

  export const PERIOD_TO_HOURS = {
    Day: 24,
    Week: 24 * 7,
    Month: 24 * 30,
    ThreeMonths: 24 * 30 * 3,
  };

  export const PERIOD_TO_LINES = {
    Day: 288,
    Week: 2016,
    Month: 8640,
    ThreeMonths: 25920,
  };

  export const periodScopeChoices = [
    { value: "Day", label: "1 Day" },
    { value: "Week", label: "1 Week" },
    { value: "Month", label: "1 Month" },
  ];

  export const periodScopeChoicesWith3Months = [
    ...periodScopeChoices,
    { value: "ThreeMonths", label: "3 Months" },
  ];

  export const TIMEWINDOW_MAX_MAP = {
    2: 1000 * 60 * 2,
    200: 1000 * 60 * 2,
    5: 1000 * 60 * 5,
    500: 1000 * 60 * 5,
    10: 1000 * 60 * 10,
    1000: 1000 * 60 * 10,
  };

  export const formats = {
    noDecimals: d3.format(".0f"),
    oneDecimal: d3.format(".1f"),
    twoDecimals: d3.format(".2f"),
    threeDecimals: d3.format(".3f"),
    fourDecimals: d3.format(".4f"),
  };